import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import SignatureCanvas from "react-signature-canvas";

export default function StepSignAndSubmit({ signatureRef }) {
  return (
    <Box component="section" className="nsp_step">
      <Typography variant="subtitle1" sx={{ fontWeight: 700, mb: 1 }}>
        Please sign in the box:
      </Typography>
      <Paper
        variant="outlined"
        sx={{
          borderColor: "primary.main",
          borderRadius: 2,
          overflow: "hidden",
          width: "100%",
          mb: 2,
        }}
      >
        <SignatureCanvas
          penColor="black"
          canvasProps={{ className: "sigCanvas" }}
          ref={signatureRef}
        />
      </Paper>
      <Box>
        <Button
          variant="outlined"
          color="error"
          onClick={() => signatureRef?.current?.clear()}
        >
          Clear Signature
        </Button>
      </Box>
    </Box>
  );
}
